export const testMerchantUserPassword = (password) => {
  if (!password) {
    return false
  }
  const hasDigit = /\d/.test(password)
  const hasAlphabet = /[a-zA-Z]/.test(password)
  const has6Chars = password.length >= 6
  return hasDigit && hasAlphabet && has6Chars
}
